import React, { useState } from "react";
import SunIcon from "../../assets/images/sun-icon.png";
import GeneralEnquiriesIcon from "../../assets/images/general-enquiries-icon.png";
import BotanicLogo from "../../assets/images/botanic-logo.png";
import WelcomeLogo from "../../assets/images/welcome-logo.png";
import HighlightIcon from "../../assets/images/highlights-icon.png";
import WayfinderIcon from "../../assets/images/wayfinder-icon.png";
import ResourcesIcon from "../../assets/images/resources-icon.png";

import Layout from "../../components/Layout";
import { Link } from "react-router-dom";
import { useStores } from "../../use.store";
import { getAppLogo, getInformationAsset } from "../../helpers";
import Weather from "../../components/WeatherComponent";
import ModalFeedback from "../../components/ModalFeedback";
import ButtonSmileAvatar from "../../components/ButtonSmileAvatar";

const HomePage = () => {
  const { mainStore } = useStores();
  const [isOpenFeedback, setIsOpenFeedback] = useState(false);

  const menus = [
    // {
    //   name: mainStore.homeMenuHighlightsLabel ?? "Highlights",
    //   icon: getInformationAsset(
    //     mainStore.config,
    //     mainStore.homeMenuHighlightsLogo,
    //     HighlightIcon,
    //   ),
    //   slug: "highlights",
    // },
    {
      name: mainStore.homeMenuGeneralEnquiriesLabel ?? "General Enquiries",
      icon: getInformationAsset(
        mainStore.config,
        mainStore.homeMenuGeneralEnquiriesLogo,
        GeneralEnquiriesIcon,
      ),
      slug: "general-enquiries",
    },
    // {
    //   name: mainStore.homeMenuWayfinderLabel ?? "Wayfinder",
    //   icon: getInformationAsset(
    //     mainStore.config,
    //     mainStore.homeMenuGeneralEnquiriesLogo,
    //     WayfinderIcon,
    //   ),
    //   slug: "wayfinder",
    // },
    {
      name: mainStore.homeMenuResourcesLabel ?? "Resources",
      icon: getInformationAsset(
        mainStore.config,
        mainStore.homeMenuResourcesLogo,
        ResourcesIcon,
      ),
      slug: "resources",
    },
  ];
  return (
    <Layout>
      <div
        // className="bg-[#215732] text-white px-4 py-6 h-[165px]"
        className="bg-[#215732] text-white px-4 py-6 h-[clamp(120px,34vw,165px)]"
      >
        <div className="flex justify-between items-start mb-6">
          <img
            src={getAppLogo(mainStore.config, mainStore.appLogo)}
            alt="Botanic Garden Logo"
            className="w-[120px] h-[60px] object-contain"
          />

          <div className="text-right">
            <Weather link={mainStore.weatherLink} />
          </div>
        </div>

        {/* Welcome Section */}
        <div className="absolute left-1/2 -translate-x-1/2 top-[65px]">
          <img
            src={getInformationAsset(
              mainStore.config,
              mainStore.homeLogo,
              WelcomeLogo,
            )}
            alt="Weather Icon"
            // className="w-[146px] h-[146px]"
            className="w-[clamp(100px,32vw,146px)] h-auto"
          />
        </div>
      </div>

      <div className="flex flex-col h-[600px] px-4 py-[80px] justify-center items-center align-center">
        <div className="flex flex-col justify-center items-center align-center">
          <h1 className="text-[30px] text-black text-center mb-8">
            {mainStore.homeHeaderLabel ?? "How Can We Help?"}
          </h1>

          <div className="grid grid-cols-2 gap-4 max-w-md mx-auto h-full">
            {menus.map((menu, index) => (
              <Link
                className="bg-white rounded-[20px] px-6 py-2 h-[130px] w-[130px] border-[0.5px] border-[#7A9A01]"
                to={`/${menu.slug}`}
              >
                <div className="w-[60px] h-[60px] rounded-xl flex items-center justify-center mx-auto my-2">
                  <img
                    src={menu.icon}
                    alt="Weather Icon"
                    className="w-[55px] h-[55px]"
                  />
                </div>
                <div
                  className="text-black font-medium text-[14px] text-center h-[30px]"
                  style={{ lineHeight: "1rem" }}
                >
                  {menu.name}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

      <ButtonSmileAvatar onClick={() => setIsOpenFeedback(true)} />

      {isOpenFeedback && (
        <ModalFeedback onclose={() => setIsOpenFeedback(false)} />
      )}
    </Layout>
  );
};

export default HomePage;
